import React from 'react';
import { PropTypes } from 'prop-types';
import classNames from 'classnames/bind';
import isEmpty from 'lodash/isEmpty';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { getMonthName } from '../../utils/index';
import * as styles from './CouponSliderDetails.css';

const cx = classNames.bind(styles);

const CouponSliderDetails = (props) => {
    const couponDetails = props.couponDetailsInfo;

    const pannelHeader = (headLine) => {
        return (
            <div data-automation-id="at-coupon-name">
                <p className={dt(['text-large', 'font-open-sans', 'font-semibold'])}>{headLine}</p>
            </div>
        );
    };

    const pannelOfferHeadline = (offer, isSlider = false) => {
        const headlineBoldStyle = dt(['text-large', 'font-bold']);
        const conjunctionStyle = isSlider
            ? headlineBoldStyle
            : dt(['text-xsmall', 'font-normal', 'text-gray-60', 'py-2']);
        return isSlider ? (
            <div className={dt(['pt-7'])} data-automation-id="at-coupon-offer">
                <div>
                    {offer?.conjunction ? (
                        <span
                            className={[conjunctionStyle, dt(['pr-1'])].join(' ')}
                            data-automation-id="at-coupon-offer-conjuction"
                        >
                            {offer?.conjunction}
                        </span>
                    ) : (
                        ''
                    )}

                    <span
                        className={headlineBoldStyle}
                        data-automation-id="at-coupon-offer-headline"
                    >
                        {offer.headLine}
                    </span>
                </div>
                <div
                    className={dt(['text-base', 'font-normal'])}
                    data-automation-id="at-coupon-offer-body"
                >
                    {offer?.bodyCopy}
                </div>
            </div>
        ) : (
            <>
                {offer?.conjunction ? (
                    <div
                        className={dt(['text-xsmall', 'font-normal', 'text-gray-60', 'py-2'])}
                        data-automation-id="at-coupon-offer-conjuction"
                    >
                        {offer?.conjunction}
                    </div>
                ) : (
                    ''
                )}
                {
                    <div
                        className={dt([
                            'first:text-[28px]',
                            'text-2xlarge',
                            'first:leading-10',
                            'font-bold',
                        ])}
                        data-automation-id="at-coupon-offer-headline"
                    >
                        {offer?.headline}
                    </div>
                }
                <div
                    className={dt(['text-base', 'font-normal'])}
                    data-automation-id="at-coupon-offer-body"
                >
                    {offer?.bodyCopy}
                </div>
            </>
        );
    };

    const pannelcouponValidity = (dataItem, isSlider = false) => {
        const today = new Date();
        const tomorrow = new Date();
        const expiryDate = new Date(dataItem?.validTo);
        today.setDate(today.getDate());
        tomorrow.setDate(today.getDate() + 1);
        if (today.toDateString() === expiryDate.toDateString()) {
            return 'Today';
        }
        if (tomorrow.toDateString() === expiryDate.toDateString()) {
            return 'Tomorrow';
        }
        const expirationDate = `${getMonthName(expiryDate.getMonth())} ${expiryDate.getDate()}`;
        return isSlider ? (
            <div className={dt(['pt-7'])} data-automation-id="at-coupon-validity">
                <p className={dt(['text-base', 'font-normal', 'text-black'])}>
                    {dataItem?.promoCode ? (
                        <span>
                            Code: <span className={dt(['font-bold'])}>{dataItem?.promoCode}</span>
                        </span>
                    ) : null}
                    {dataItem?.validTo ? (
                        <span className={dt(['pl-1'])}>
                            Expires <span className={dt(['font-bold'])}>{expirationDate}</span>
                        </span>
                    ) : null}
                </p>
            </div>
        ) : null;
    };

    const pannelcouponDisclaimer = (disclaimerText) => {
        const regularExp = /<p>(.*?)<\/p>/g;

        const matchesText = disclaimerText.match(regularExp);

        const conditionsText = `<span class=${dt(['font-bold'])}>Conditions :</span>`;
        const exclusionsText = `<span class=${dt(['font-bold'])}>Exclusions :</span>`;
        const disclaimertexts = matchesText.map((item) => {
            const inittext = item.substring(0, 3);
            const endtext = item.substring(3);
            if (matchesText.indexOf(item) === 0) {
                return inittext + conditionsText + endtext;
            }
            return inittext + exclusionsText + endtext;
        });
        if (disclaimertexts[1] === undefined) {
            return disclaimertexts[0];
        }

        return disclaimertexts[0] + disclaimertexts[1];
    };

    const renderCouponDetailsContent = (dataItem) => {
        const couponArrayList = [];

        couponArrayList.push(pannelHeader(dataItem?.name, true));

        // eslint-disable-next-line array-callback-return
        dataItem.offers.map((item) => {
            couponArrayList.push(pannelOfferHeadline(item, true));
        });

        couponArrayList.push(pannelcouponValidity(dataItem, true));

        couponArrayList.push(
            !isEmpty(dataItem?.disclaimerText?.html) ? (
                <div
                    className={dt(['pt-7'])}
                    data-automation-id="at-coupon-disclaimer"
                    dangerouslySetInnerHTML={{
                        __html: pannelcouponDisclaimer(dataItem?.disclaimerText?.html),
                    }}
                />
            ) : null
        );

        return (
            <div>
                <div
                    className={`${dt(['py-4', 'px-6', 'flex', 'flex-col'])} ${cx(
                        'couponDetailsBlock'
                    )}`}
                    data-automation-id="couponDetailsContainer"
                >
                    {couponArrayList.map((item) => item)}
                </div>
            </div>
        );
    };
    return <>{renderCouponDetailsContent(couponDetails[0])}</>;
};

CouponSliderDetails.propTypes = {
    couponDetailsInfo: PropTypes.array,
};

CouponSliderDetails.defaultProps = {
    couponDetailsInfo: [],
};

export default CouponSliderDetails;
